module.exports = __webpack_public_path__ + "static/media/ouzeria_thumb.99d52f03.jpg";